import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

// Which sensor the project dashboard's gauges read from. A project that has
// never chosen still answers, with the LATEST default.
export const getDashboardGaugeSetting = async (projectId) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `projects/${projectId}/renolog/dashboard-gauges`,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
